import React from 'react';
import { CheckCheck } from 'lucide-react';
import './ButtonLeido.css';

const ButtonLeido = ({ onClick, disabled = false, children = 'Leído' }) => {
  return (
    <button className="boton-leido" onClick={onClick} disabled={disabled} title="Marcar como leída">
      <CheckCheck />
      <span>{children}</span>
    </button>
  );
};

export default ButtonLeido;
